import * as React from "react"
import { AfterPage } from "types/afterjs"
import { useToast, useAuthActions } from "hooks"
import { ToastData } from "components/toast/ToastProvider"
import { Seo } from "components"

interface LogoutPage {
	//
}

const message: ToastData = {
	icon: "success",
	header: "حساب کاربری",
	text: "از حساب کاربری خود خارج شدید.",
}

const LogoutPage: AfterPage<LogoutPage> = ({ history }) => {
	const toast = useToast()
	const { logout } = useAuthActions()
	const firstTime = React.useRef(true)

	React.useEffect(() => {
		if (!firstTime.current) {
			return
		}

		firstTime.current = false
		logout()
		toast(message)
		history.push("/")
	}, [logout, toast, history])

	return (
		<>
			<Seo
				title="خروج از حساب کاربری"
				description="خروج از حساب کاربری"
				path="/logout"
			/>
			<p>لطفا کمی صبر کنید</p>
		</>
	)
}

export default LogoutPage
